import {
  Pipe,
  PipeTransform
} from '@angular/core';
import dayjs from 'dayjs';
import { IShow } from '../../features/shows/core/interfaces/IShow';

@Pipe({
  name: 'showsByDate',
  standalone: true
})
export class ShowsByDatePipe implements PipeTransform {

  public transform(shows: IShow[], date: 'today' | 'tomorrow' | dayjs.Dayjs = 'today'): IShow[] {

    const selectedDate =
      date === 'today'
        ? dayjs()
        : date === 'tomorrow'
          ? dayjs().add(1, 'day')
          : date;

    const cinemaDayStartDate = selectedDate.startOf('day').add(6, 'hour');
    const cinemaDayEndDate = cinemaDayStartDate.add(1, 'day');

    return shows.filter(show => {
      const beginning = dayjs(show.beginning);

      return !beginning.isBefore(cinemaDayStartDate) && beginning.isBefore(cinemaDayEndDate);
    });
  }
}
